// extracted by mini-css-extract-plugin
export default {"shortTips":"index_shortTips_Aqznq","fhxwkhd":"index_fhxwkhd_dnrZY"};